import {FormProvider, useForm} from 'react-hook-form'
import PropTypes from 'prop-types'

import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'

import Form from '../../shared/Form'
import Input from '../../shared/Input'

const TfaBackupLogIn = ({handleSubmit, loading, error}) => {
  const methods = useForm()
  const {errors} = methods.formState

  return (
    <Paper elevation={3} component='div' className='tfa-backup-login center-layout'>
      <Typography variant='h5' color='primary'>TFA LogIn</Typography>
      <Typography variant='body1' color='primary' gutterBottom>
        Please enter your 16 digits backup code.
      </Typography>
      <Typography variant='body2' color='primary' gutterBottom>
        Successful login would disable your TFA and you'll need to set it up again.
      </Typography>
      {error && <Alert severity='error' sx={{marginBottom: '10px'}}>{error}</Alert>}
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit}>
          <Input
            error={!!errors.backupCode}
            label='Backup Code'
            name='backupCode'
            options={{required: 'Backup Code is required'}}
            helperText={errors.backupCode?.message}
            margin='dense'
          />
          <Button
            disabled={loading}
            type='submit'
            variant='contained'
            sx={{color: '#F7F7F7'}}>
            Sign In
          </Button>
        </Form>
      </FormProvider>
    </Paper>
  )
}

TfaBackupLogIn.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.string,
  handleSubmit: PropTypes.func
}

export default TfaBackupLogIn